export const NECKSOUND_ENABLED_HOSPITALS = [
    'samsung', 
    // 여기에 NeckSoundCheck 기능을 활성화할 병원 ID를 추가하세요.
];

export const isNeckSoundEnabled = (hospitalId: string | undefined): boolean => {
    // 병원 ID가 유효한 문자열이고, 활성화 목록에 포함되어 있으면 true 반환
    if (!hospitalId) return false;
    return NECKSOUND_ENABLED_HOSPITALS.includes(hospitalId);
};